import * as api from '../api/index.js';
import QuotaUsersScreen from '../components/QuotaUsersScreen';

export default function OverQuotaUsersPage() {
  return (
    <QuotaUsersScreen
      variant="over-quota"
      title="Over Quota Users"
      subtitle="Fetch over-quota respondents for a study and filter by contact ID (cnt_id), quota type (cnq_type), or quota name."
      fetchUsersApi={api.getOverQuotaUsers}
      showReviveAction
    />
  );
}
